import facepaint from 'facepaint'
import { FC } from 'react'
import ReactDOM from 'react-dom'
import { usePlayerState } from '../contexts/playerState'
import { formatNumber } from '../utils'
import { mqs } from '../utils/theme'

interface TotalViewersPropTypes {
  totalViewers?: number
}

const TotalViewersDefaultProps = {
  totalViewers: 0,
}

const TotalViewers: FC<TotalViewersPropTypes> = ({
  totalViewers,
}) => {
  const { isInitialized, playerInstance: player, isLive } = usePlayerState()
  const formatedTotalViewers = formatNumber(totalViewers || 0)

  if (!isInitialized || !player) return null

  return (
    (isLive &&
      totalViewers &&
      totalViewers > 1 &&
      ReactDOM.createPortal(
        <div css={wrapperStyle} className="vjs-total-viewers vjs-button">
          <div css={totalViewersBoxStyle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              css={eyeIconStyle}
            >
              <path
                d="M14 12c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2zm10-.449s-4.252 7.449-11.985 7.449c-7.18 0-12.015-7.449-12.015-7.449s4.446-6.551 12.015-6.551c7.694 0 11.985 6.551 11.985 6.551zm-8 .449c0-2.208-1.791-4-4-4-2.208 0-4 1.792-4 4 0 2.209 1.792 4 4 4 2.209 0 4-1.791 4-4z"
                fill="#FFF"
              />
            </svg>
            {formatedTotalViewers}
          </div>
        </div>,
        player.controlBar.el(),
      )) ||
    null
  )
}

TotalViewers.defaultProps = TotalViewersDefaultProps

export default TotalViewers

const mq = facepaint([mqs.m])

const wrapperStyle = {
  order: 31,
  display: 'flex',
  alignItems: 'center',
  height: '40px',
}

const totalViewersBoxStyle = mq({
  fontSize: '1.2em',
  fontWeight: 'bold' as const,
  padding: '2px 8px 2px 4px',
  backgroundColor: 'rgba(0,0,0,0.2)',
  boxShadow: ['unset', '0 2px 4px rgba(0,0,0,0.5)'],
  borderRadius: '2px',
  display: 'flex',
  alignItems: 'center',
})

const eyeIconStyle = {
  height: '16px',
  marginRight: '4px',
}
